import GestionIngresos from "./GestionIngresos";
export default GestionIngresos;